import React, { forwardRef } from 'react';
import { movdFocus, movdTokens } from './movdTokens.js';

const MovdInput = forwardRef(function MovdInput({ label, error, helperText, style, inputStyle, ...props }, ref) {
  return (
    <label style={{ display: 'grid', gap: 8, color: movdTokens.color.tealSoft, fontSize: 11, fontWeight: 900, letterSpacing: '.14em', textTransform: 'uppercase', ...style }}>
      {label && <span>{label}</span>}
      <input
        ref={ref}
        {...props}
        aria-invalid={Boolean(error)}
        style={{
          width: '100%',
          minHeight: 52,
          boxSizing: 'border-box',
          padding: '0 15px',
          borderRadius: movdTokens.radius.control,
          border: `1px solid ${error ? movdTokens.color.danger : 'rgba(255,255,255,.28)'}`,
          background: movdTokens.color.paper,
          color: movdTokens.color.ink,
          font: 'inherit',
          fontSize: 16,
          fontWeight: 700,
          letterSpacing: 0,
          textTransform: 'none',
          ...inputStyle,
        }}
        onFocus={event => {
          event.currentTarget.style.outline = movdFocus.outline;
          event.currentTarget.style.outlineOffset = `${movdFocus.outlineOffset}px`;
          props.onFocus?.(event);
        }}
        onBlur={event => {
          event.currentTarget.style.outline = '';
          props.onBlur?.(event);
        }}
      />
      {(error || helperText) && <span role={error ? 'alert' : undefined} style={{ color: error ? movdTokens.color.danger : movdTokens.color.textMuted, fontSize: 12, letterSpacing: 0, textTransform: 'none' }}>{error || helperText}</span>}
    </label>
  );
});

export default MovdInput;
